import { render, staticRenderFns } from "./cardsTeste.vue?vue&type=template&id=753bba66"
import script from "./cardsTeste.vue?vue&type=script&lang=js"
export * from "./cardsTeste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports